module.exports = __webpack_public_path__ + "static/media/fancy_restaurant.cb4077c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/fancy_restaurant.jpg
// module id = 79
// module chunks = 0